const shortNumeric = {
  short: {
    year: 'numeric', month: '2-digit', day: '2-digit',
  },
  long: {
    year: 'numeric', month: 'long', day: '2-digit',
  },
}

export default function (locales) {
  const formats = {}
  locales.forEach((locale) => { formats[locale] = shortNumeric })
  return formats
}
